import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useAuthStore = defineStore('auth', () => {
  // State - URL parameters from nChat iframe
  const baseUrl = ref('')
  const apiAccessToken = ref('')
  const accountId = ref('')
  const userId = ref('')

  // Devise auth params (alternative auth method)
  const accessToken = ref('')
  const client = ref('')
  const uid = ref('')

  const isAuthenticated = computed(() => {
    return !!(apiAccessToken.value && baseUrl.value && accountId.value)
  })

  /**
   * Extract auth parameters from the current URL query string.
   * Called once at app startup from main.ts.
   */
  function init(): void {
    const params = new URLSearchParams(window.location.search)

    baseUrl.value = params.get('base_url') || ''
    apiAccessToken.value = params.get('api_access_token') || ''
    accountId.value = params.get('account_id') || ''
    userId.value = params.get('user_id') || ''

    // Devise params (alternative)
    accessToken.value = params.get('access-token') || ''
    client.value = params.get('client') || ''
    uid.value = params.get('uid') || ''

    if (!isAuthenticated.value) {
      console.warn(
        '[AuthStore] Missing required auth params. Expected: base_url, api_access_token, account_id.',
        { baseUrl: baseUrl.value, hasToken: !!apiAccessToken.value, accountId: accountId.value },
      )
    }
  }

  return {
    // State
    baseUrl,
    apiAccessToken,
    accountId,
    userId,
    accessToken,
    client,
    uid,

    // Getters
    isAuthenticated,

    // Actions
    init,
  }
})
